import { render } from "./VOfflineBooking.vue?vue&type=template&id=6ea29549"
import script from "./VOfflineBooking.vue?vue&type=script&lang=js"
export * from "./VOfflineBooking.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__